import {SagaIterator} from "redux-saga";
import {call, fork, take, select, put, getContext} from "redux-saga/effects";
import {push} from "react-router-redux";
import {bindAsyncAction} from "typescript-fsa-redux-saga";
import {IceClient} from "@neolab/ice-client";

import {Ganymede} from "@slices/Ganymede/ClientManager";

import {routeSaga} from "src/utils/router";
import {logError} from "src/utils/sagas";
import {RootState} from "src/reducers";

import {
  projectsRoute, getProjects, createProject, createProjectSubmitted,
} from "./Projects.actions";


const getProjectsWorker = bindAsyncAction(getProjects)(
  function* getProjectsWorker(): SagaIterator {
    const iceClient: IceClient = yield getContext('iceClient');

    const clientManagerPrx: Ganymede.ClientManagerPrx =
      yield call(iceClient.getProxy, 'ClientManager');

    return yield call(clientManagerPrx.getProjects);
  },
);

const createProjectWorker = bindAsyncAction(createProject)(
  function* createProjectWorker({name}): SagaIterator {
    const iceClient: IceClient = yield getContext('iceClient');

    const clientManagerPrx: Ganymede.ClientManagerPrx =
      yield call(iceClient.getProxy, 'ClientManager');

    return yield call(clientManagerPrx.createProject, name);
  },
);


const projectsSaga = routeSaga(projectsRoute)(
  function* projectsSaga(): SagaIterator {
    yield fork(getProjectsWorker);

    while (true) {
      yield take(createProjectSubmitted.type);

      const name = yield select((state: RootState) =>
        state.routes.projects.newProjectName);

      try {
        const project: Ganymede.Project =
          yield call(createProjectWorker, {name});

        yield put(push(`/projects/${project.id}`));
      } catch (e) {
        logError("Error creating project", e, 'warn');
      }
    }
  },
);

export default projectsSaga;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/saga.ts